import React from 'react';
import ActionsModuleRedesignView from 'partial/OfferManager/modules/ActionsModuleRedesign/ActionsModuleRedesignView';
import { useGoals } from './hooks/ActionsModuleRedesign.hooks';
import { SingleModuleLoader } from 'pages/RedesignDashboard/components/LoadingFactorView';

export const ActionsModuleRedesign = props => {
  const {
    eventHandler,
    pagePosition,
    modulePosition,
    userInfo,
    config,
    creditInfo,
    additionalData,
  } = props;

  const { autoRefinanceLoading, autoRefinanceInfo } = useGoals({
    creditInfo,
    userInfo,
  });

  const loading = props.globalLoadingFlag || autoRefinanceLoading;

  const actions = additionalData?.actions?.filter(action =>
    action.offerModule === 'PL_PREQUAL_OFFER_SUMMARY_MODULE'
      ? action?.offers?.length > 0
      : true,
  );

  if (loading) {
    return <SingleModuleLoader singleModuleClassName={'margb30'} />;
  } else {
    return (
      <ActionsModuleRedesignView
        actionsByGoals={actions}
        eventHandler={eventHandler}
        pagePosition={pagePosition}
        modulePosition={modulePosition}
        autoRefinanceInfo={autoRefinanceInfo}
        config={config}
      />
    );
  }
};
